import { ACTIONS } from '../constants/actionTables';

/**
 * Task data mapping utility functions
 */

/**
 * Map task data for PROFILE action type
 * @param {Object} task - Original task object
 * @param {string} machineGroupName - Machine group name
 * @param {string} machineGroupImg - Machine group image
 * @returns {Object} Mapped task data
 */
function mapProfileTaskData(task, machineGroupName, machineGroupImg) {
  const interval = JSON.parse(task.maintenance.interval);
  // Description can be either JSON (Draft.js format) or plain text
  // Don't parse here - let useTaskData handle it with error handling
  const description = task.maintenance.description;

  return {
    machineId: task.machine.id,
    maintenanceId: task.maintenance.id,
    createdAt: task.created_at,
    updatedAt: task.updated_at,
    intervalType: interval.type,
    intervalValue: interval.value,
    notifyTime: task.maintenance.notification_lead_time,
    status: task.status,
    machineName: task.machine.name,
    machineNumber: task.machine.number,
    groupName: machineGroupName,
    groupImage: machineGroupImg,
    maintenanceName: task.maintenance.name,
    filename: task.filename,
    original_filename: task.original_filename,
    comment: task.comment,
    description,
  };
}

/**
 * Map task data for CALENDAR action type
 * @param {Object} task - Original task object
 * @returns {Object} Mapped task data
 */
function mapCalendarTaskData(task) {
  return {
    machineId: task.extendedProps?.machineId || task.machineId || '',
    maintenanceId: task.extendedProps?.maintanenceId || task.maintanenceId || '',
    createdAt: task.extendedProps?.createdAt || task.createdAt || '',
    updatedAt: task.extendedProps?.updatedAt || task.updatedAt || '',
    completedAt: task.extendedProps?.completedAt || task.completedAt || '',
    status: task.extendedProps?.status || task.status || '',
    machineName: task.extendedProps?.machineName || task.machineName || '',
    machineNumber: task.extendedProps?.machineNumber || task.machineNumber || '',
    groupName: task.extendedProps?.groupName || task.groupName || '',
    groupImage: task.extendedProps?.groupImage || task.groupImage || '',
    maintenanceName: task.extendedProps?.maintenanceName || task.maintenanceName || '',
    filename: task.extendedProps?.filename || task.filename || '',
    original_filename: task.extendedProps?.original_filename || task.original_filename || '',
    comment: task.extendedProps?.comment || task.comment || '',
    intervalType: task.extendedProps?.intervalType || task.intervalType || '',
    intervalValue: task.extendedProps?.intervalValue || task.intervalValue || '',
    notifyTime: task.extendedProps?.notifyTime || task.notifyTime || '',
    description: task?.extendedProps?.description || task.description || '',
    title: task._def?.title || task.maintenanceName || '',
    responsibleLastname: task?.extendedProps?.responsibleLastname || task?.responsibleLastname || '',
    responsibleFirstname: task?.extendedProps?.responsibleFirstname || task?.responsibleFirstname || '',
  };
}

/**
 * Map task data based on action type
 * @param {Object} task - Original task object
 * @param {string} type - Action type (PROFILE or CALENDAR)
 * @param {string} machineGroupName - Machine group name (for PROFILE type)
 * @param {string} machineGroupImg - Machine group image (for PROFILE type)
 * @returns {Object|null} Mapped task data or null if invalid
 */
export function mapTaskData(task, type, machineGroupName = '', machineGroupImg = '') {
  if (!task) return null;

  if (type === ACTIONS.PROFILE) {
    return mapProfileTaskData(task, machineGroupName, machineGroupImg);
  }

  if (type === ACTIONS.CALENDAR) {
    return mapCalendarTaskData(task);
  }

  return null;
}